import { useMainContext } from "../contexts/main";
import { useSocketContent } from "../contexts/socket-content";
import {
    DText,
    TradeBoxHeader,
    FlexCenter,
    Padding,
    ScrollWrap,
    FlexStart,
    FlexEnd,
    GlobalLoadingWrapper,
    TradeAnimateItem, ColorText
} from "../styles/CommonStyles";
import { formatDate, formatNumber } from "../utils/common";
import Text from "../utils/Text";
import { LastTradesBox } from "../styles/BoxingStyles"
import NoData from "./common/utils/NoData";
import {PuffLoader} from "react-spinners";
import Loading from "./common/loading/Loading";
import {useEffect, useState} from "react";
import {MOBILE_SIZE} from "../constants/common";
import {useWindowSize} from "../hooks/common/useWindowSize";


const LastTrades = () => {

    const { trades } = useSocketContent()
    const { main: { lang }, _loading } = useMainContext()
    const { width } = useWindowSize()

    const [lastTrade, setLastTrade] = useState(null)
    const [tradesOnBoard, setTradesOnBoard] = useState([])
    const [shouldAnimateTradeItems, setShouldAnimateTradeItems] = useState([])

    useEffect(() => {

        if (trades?.length) {

            let temp = []
            const lastIndex = trades.findIndex(t => getUniqueDate(t) === lastTrade)
            if (lastIndex !== -1) {
                temp = trades?.slice(0, lastIndex).map(item => (getUniqueDate(item)))
            }

            setShouldAnimateTradeItems(temp)
            setTradesOnBoard(trades)
            setLastTrade(getUniqueDate(trades[0]))

        }else {
            setLastTrade([])
        }
    }, [trades])


    const getUniqueDate = (item) => {
        return new Date(item.createdAt).getTime()
    }

    return (
        <LastTradesBox>
            {width > MOBILE_SIZE &&
                <TradeBoxHeader>
                    <DText><Text tid="latest-trades" /></DText>
                </TradeBoxHeader>
            }

            <FlexCenter>
                <Padding padding="10px 0">
                    {headers.map((header, idx) => (
                        idx === 0 ?
                            <FlexStart key={header} width="33%">
                                <DText fontSize=".7rem"><Text tid={header} /></DText>
                            </FlexStart>
                            :
                            <FlexEnd key={header} width="30%">
                                <DText fontSize=".7rem"><Text tid={header} /></DText>
                            </FlexEnd>

                    ))}
                </Padding>
            </FlexCenter>
            <ScrollWrap height="calc(100% - 120px)">
                {tradesOnBoard?.length ?
                    tradesOnBoard.map(trade => (
                        <TradeAnimateItem
                            key={trade.createdAt}
                            animate={
                                shouldAnimateTradeItems.includes(getUniqueDate(trade))
                            }
                            type={trade.type}>
                            <Padding padding="2px 0">
                                <FlexStart width="33%">
                                    <ColorText type="number" tradeType={trade.type}>
                                        {formatNumber(trade.priceUnit)}
                                    </ColorText>
                                </FlexStart>
                                <FlexEnd type="number" width="30%">
                                    <DText>
                                        {formatNumber(trade.amount, { point: 6 })}
                                    </DText>
                                </FlexEnd>
                                <FlexEnd width="30%">
                                    <DText>
                                        {formatDate(trade.createdAt, "time", lang === "en" ? "en-US" : "fa-IR")}
                                    </DText>
                                </FlexEnd>
                            </Padding>
                        </TradeAnimateItem>
                    ))
                    :
                    <FlexCenter height="100%">
                        <NoData size={50} />
                    </FlexCenter>
                }
            </ScrollWrap>
            {_loading &&
                <GlobalLoadingWrapper>
                    <PuffLoader size={24} color="#2697ff" />
                </GlobalLoadingWrapper>
            }
            <Loading loading={!trades} />
        </LastTradesBox>
    )
}

const headers = [
    "price", "amount", "time"
]


export default LastTrades;
